import React from "react";
import { ServicesTemplate } from "../../Templates/ServicesTemplate";

export const Services = () => {
  return <ServicesTemplate />;
};
